"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionAreaButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBClickable = _interopRequireDefault(require("../../HBClickable/HBClickable"));
var ActionAreaButton = exports.ActionAreaButton = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBActionAreastyles__ActionAreaButton",
  componentId: "sc-1hueyik-0"
})(["all:unset;cursor:pointer;&:hover,:focus{all:unset;}&[disabled]{cursor:not-allowed;}&[data-is-empty=\"true\"]{position:absolute;inset:0;},"]);
//# sourceMappingURL=HBActionArea.styles.js.map